import { TrialsChatAvailabilityPollingService } from 'src/trials/services/trials-chat-availability-polling.service';
import { provideChat } from '../providers/chat.providers';
import { AppointmentsStore } from './appointments/appointments.store';
import { OnDemandStore } from './on-demand/on-demand.store';
import { PolicyStore } from './policy/policy.store';
import { TreatmentPlansStore } from './treatment-plans/treatment-plans.store';
import { UserStore } from './user.store';

/**
 * List of stores that are used when the user is authenticated.
 * This is used so the stores can be provided to the application when the user is authenticated.
 */
export const AuthenticatedStoreProviders = [
  AppointmentsStore,
  // ChatStore,
  OnDemandStore,
  TreatmentPlansStore,
  PolicyStore,
  ...provideChat(),
];

/**
 * Chat-only providers for the trials app (no PolicyStore or other app-specific stores).
 * Chat stores (ChatConnectionStore, ChatAvailabilityStore) use withUser()/withTenant() which
 * inject UserStore; trials app root may not provide it when the route is lazy-loaded, so we
 * provide UserStore here.
 */
export const TrialsAuthenticatedStoreProviders = [UserStore, ...provideChat(), TrialsChatAvailabilityPollingService];
